<selfai-platform-models-registry-list
></selfai-platform-models-registry-list>
